/*
 * This plugin provides ajax support for Foundation Reveal modals
 * that was removed in Foundation 6.
 */
(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
		define(['jquery'], function($){
			return (root.VFDPRevealAjax = factory($));
		});
	} else if ( typeof exports === 'object' ) {
		module.exports = (root.VFDPRevealAjax = factory(require('jquery')(root)));
	} else {
		root.VFDPRevealAjax = factory(root.jQuery);
	}
})(typeof global !== "undefined" ? global : this.window || this.global, function ($) {

	"use strict";
	
	// Foundation 6 uses `data-open` as a trigger to open reveal modals.
	// This allows for AJAX content to be loaded, add `data-open` to the 
	// triggering element. <a> elements will use the `href` attribute as the
	// endpoint for the ajax content. Anchors with an href="#" will be ignored.
	// If any other element is used add a `data-open-ajax` attribute that
	// points to the AJAX endpoint.
	//
	// <a data-open="modalToOpenID" href="/example/modal/content.html">Open's and AJAX modal</a>
	//
	// <button data-open="modalToOpenID" data-open-ajax="/example/modal/content.html">Open's and AJAX modal</button>
	//
	return $(document).on('click.zf.trigger', '[data-open]a[href]:not([href="#"]), [data-open][data-open-ajax]', function(event) {
		// Check if we have a valid version of foundation reveal loaded.
		// Because of timing issues from this being listed as a
		// dependency, we cannot verify this prior to binding the
		// event handler. If we don't, bail out, it's not safe to proceed
		if(!window.Foundation || !window.Foundation._plugins || !window.Foundation._plugins.reveal)
			return;
		
		// This might be a link with a href to a webpage.
		// Stop the default from happening, just in case.
		event.preventDefault();
		
		// Prevent other listeners at this level from operating.
		// The key is to bind this listener before foundation listener
		// So listing this module as a dependency of foundation Reveal 
		// should load this module before foundation reveal
		event.stopImmediatePropagation();
		
		var $this = $(this),
			// Use the data-open-ajax attribute first, href second.
			// This was we can use a non-ajax href endpoints on <a>
			// elements incase the function fails or JS is disabled
			url = $this.data('open-ajax') || $this.attr('href'),
			// Look for foundation 6 syntax first
			modalId = $this.data('open'),
			$modal = $('#'+modalId);
		
		// Use jQuery ajax to get the content and open the modal
		$.ajax({
			url: url
		}).done(function(response) {
			// Set the modal contents
			$modal.html(response);
			// Enable the reveal plugin if not setup yet.
			var plugin = $modal.data('zfPlugin');
			if(!plugin || !(plugin instanceof Foundation.Reveal))
				new Foundation.Reveal($modal);
			// Because of the async request for ajax calls, access
			// to the original event is lost. Adding the original
			// event as part of the modal data will help provide
			//  a chain of events.
			$modal.data('originalEvent', event);
			// Open the modal with the contents
			$modal.foundation('open');
		}).fail(function(jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		});
	});
});
